/*
 * 订单确认
 * */
import request from "@utils/request";
import store from "@utils/store/cookie";

 
 
/**
 * 通过购物车 id 获取订单信息
 * @param cartId
 * @returns {*}
 */
export function postOrderConfirm(cartId) {
  return request.post("/order/confirm", { cartId });
}

/**
 * 计算订单金额
 * @param key
 * @param data
 * @returns {*}
 */
export function postOrderComputed(key, data) {
  return request.post("/order/computed/" + key, data);
}

/**
 * 获取指定金额可用优惠券
 * @param price
 * @returns {*}
 */
export function getOrderCoupon(price, data) {
  return request.get("/coupons/order/" + (parseFloat(price) || 0), data);
}
/**
 * 保存常用产品
 * @param key
 * @param data
 * @returns {*}
 */
export function savegoods(data) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	 const uid =  user.uid;
	 console.log(uid);
  return request.post("/admin/app/newaddgoods/", {member_id:uid,data: data  } );
}
/**
 * 生成订单
 * @param key
 * @param data
 * @returns {*}
 */
export function createOrder(data) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	 const uid =  user.uid;
	 console.log(uid);
  return request.post("/admin/app/newaddorder/", {member_id:uid,data: data  } );
}
/**
 * 库房订单统计数据
 * @returns {*}
 */
export function getkufangOrderData() {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	 const uid =  user.uid;
	
  return request.post("/admin/app/orderkufangdata", {member_id:uid});
}
/**
 * 订单统计数据
 * @returns {*}
 */
export function getOrderData() {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	 const uid =  user.uid;
  return request.post("/admin/app/orderdata", {member_id:uid});
}
/**
 * 采购统配订单统计数据
 * @returns {*}
 */
export function getcaigoutongpeiOrderData() {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	 const uid =  user.uid;
  return request.post("/admin/app/ordercaigoutongpeidata", {member_id:uid});
}
/**
 * 采购直配订单统计数据
 * @returns {*}
 */
export function getcaigouzhipeiOrderData() {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	 const uid =  user.uid;
  return request.post("/admin/app/ordercaigouzhipeidata", {member_id:uid});
}

/**
 * 采购库房订单统计数据
 * @returns {*}
 */
export function getcaigoukufangOrderData() {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	 const uid =  user.uid;
  return request.post("/admin/app/ordercaigoukufangdata", {member_id:uid});
}
/**
 * 采购统配订单列表
 * @returns {*}
 */
export function getcaigoutongpeiOrderList(data) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	const uid =  user.uid;
	console.log(data);
  return request.post("/admin/app/getcaigoutongpeiorder/", {member_id:uid,data: data  } );
}
/**
 * 采购库房订单列表
 * @returns {*}
 */
export function getcaigoukufangOrderList(data) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	const uid =  user.uid;
	console.log(data);
  return request.post("/admin/app/getcaigoukufangorder/", {member_id:uid,data: data  } );
}
/**
 * 采购直配订单列表
 * @returns {*}
 */
export function getcaigouzhipeiOrderList(data) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	const uid =  user.uid;
	console.log(data);
  return request.post("/admin/app/getcaigouzhipeiorder/", {member_id:uid,data: data  } );
}
export function getcaigouzhipeiOrderListdm(data) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	const uid =  user.uid;
	console.log(data);
  return request.post("/admin/app/getcaigouzhipeiorderdm/", {member_id:uid,data: data  } );
}

 
/**
 * 汇总订单统计数据
 * @returns {*}
 */
export function gethuizongOrderData() {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	 const uid =  user.uid;
  return request.post("/admin/app/orderhuizongdata", {member_id:uid});
}
/**
 * 库房汇总订单
 * @returns {*}
 */
export function kufanghuizongorder() {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	 const uid =  user.uid;
  return request.post("/admin/app/addkufanghuizong", {member_id:uid});
}
/**
 * 汇总订单
 * @returns {*}
 */
export function huizongorder() {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	 const uid =  user.uid;
  return request.post("/admin/app/addhuizong", {member_id:uid});
}
/**
 * 库房订单列表
 * @returns {*}
 */
export function getkufangOrderList(data) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	const uid =  user.uid;
	console.log(data);
  return request.post("/admin/app/getkufangorder/", {member_id:uid,data: data  } );
}
/**
 * 订单列表
 * @returns {*}
 */
export function getOrderList(data) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	const uid =  user.uid;
	console.log(data);
  return request.post("/admin/app/getorder/", {member_id:uid,data: data  } );
}
/**
 * 汇总订单列表
 * @returns {*}
 */
export function gethuizongOrderList(data) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
	const uid =  user.uid;
	console.log(data);
  return request.post("/admin/app/gethuizongorder/", {member_id:uid,data: data  } );
}
/**
 * 获取订单商品
 * @returns {*}
 */
export function getcart(id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/getcart/", { member_id:uid,id:id });
}

/**
 * 重新提交订单
 * @returns {*}
 */
export function tijiaoorder(id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/tijiaoorder/", { member_id:uid,id:id });
}
/**
 * 删除直配商品
 * @returns {*}
 */
export function shanchuzhipeigoods(id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/shanchuzhipeigoods/", { member_id:uid,id:id });
}
/**
 * 删除统配商品
 * @returns {*}
 */
export function shanchutongpeigoods(id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/shanchutongpeigoods/", { member_id:uid,id:id });
}
/**
 * 删除商品
 * @returns {*}
 */
export function shanchugoods(id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/shanchugoods/", { member_id:uid,id:id });
}
/**
 * 修改统配商品
 * @returns {*}
 */
export function edittongpeigoods(id,gys_id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/edittongpeigoods/", { member_id:uid,id:id,gys_id:gys_id });
}
/**
 * 修改库主心商品供应商
 * @returns {*}
 */
export function editkufanggoods(id,gys_id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/editkufanggoods/", { member_id:uid,id:id,gys_id:gys_id });
}
/**
 * 修改直配商品
 * @returns {*}
 */
export function editzhipeigoods(id,gys_id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/editzhipeigoods/", { member_id:uid,id:id,gys_id:gys_id });
}
/**
 * 修改采购商品
 * @returns {*}
 */
export function editcaigougoods(id,gys_id,cgd_id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/editcaigougoodsgys/", { member_id:uid,id:id,gys_id:gys_id,cgd_id:cgd_id });
}
/**
 * 修改商品
 * @returns {*}
 */
export function editgoods(id,sl) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/editgoods/", { member_id:uid,id:id,sl:sl });
}
/**
 * 审核库房订单
 * @returns {*}
 */
export function kufangshenhe(id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
	 
  return request.post("/admin/app/kufangshenhe/", { member_id:uid,id:id });
}
/**
 * 审核直配订单
 * @returns {*}
 */
export function zhipeishenhe(id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
	 
  return request.post("/admin/app/caigoushenhe/", { member_id:uid,id:id });
}
/**
 * 审核统配订单
 * @returns {*}
 */
export function tongpeishenhe(id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
	 
  return request.post("/admin/app/tongpeishenhe/", { member_id:uid,id:id });
}
/**
 * 取消订单
 * @returns {*}
 */
export function cancelOrder(id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/ordercancel/", { member_id:uid,id:id });
}
/**
 * 退回订单
 * @returns {*}
 */
export function tuihuiOrder(id,dm_id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/ordertuihui/", { member_id:uid,id:id,dm_id:dm_id });
}
/**
 * 订单详情
 * @returns {*}
 */
export function orderDetail(id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/orderxq/", {member_id:uid,id:id});
}
/**
 * 统配订单详情
 * @returns {*}
 */
export function ordertongpeiDetail(id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/ordertongpeixq/", {member_id:uid,id:id});
}
/**
 * 库房订单详情
 * @returns {*}
 */
export function orderkufangDetail(id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/orderkufangxq/", {member_id:uid,id:id});
}
/**
 * 直配订单详情
 * @returns {*}
 */
export function orderzhipeiDetail(id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/orderzhipeixq/", {member_id:uid,id:id});
}
/**
 * 采购订单详情
 * @returns {*}
 */
export function ordercaigouDetail(id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/ordercaigouxq/", {member_id:uid,id:id});
}
/**
 * 采购商品详情
 * @returns {*}
 */
export function ordercaigougoodsDetail(id,cgd_id,cp_id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/ordercaigougoodsxq/", {member_id:uid,id:id,cgd_id:cgd_id,cp_id:cp_id});
}
/**
 * 汇总订单详情
 * @returns {*}
 */
export function orderhuizongDetail(id,dm_id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/orderhuizongxq/", {member_id:uid,id:id,dm_id:dm_id});
}
/**
 * 库房汇总订单详情
 * @returns {*}
 */
export function orderkufanghuizongDetail(id) {
	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
  return request.post("/admin/app/orderkufanghuizongxq/", {member_id:uid,id:id});
}
/**
 * 获取供应商列表
 * @returns {*}
 */
export function getgyslist() {
		 	const userInfo = localStorage.getItem('userInfo'); 
 const user = JSON.parse(userInfo);
		const uid =  user.uid;
		console.log(uid);
  return request.get("/admin/app/appgetgyslist", {member_id:uid});
}
/**
 * 退款理由
 * @returns {*}
 */
export function getRefundReason() {
  return request.get("/order/refund/reason");
}

/**
 * 提交退款
 * @returns {*}
 */
export function postOrderRefund(data) {
  return request.post("/order/refund/verify", data);
}

/**
 * 确认收货
 * @returns {*}
 */
export function takeOrder(uni) {
	 console.log(uni);
  return request.get("/admin/app/getorder", { uni });
}

/**
 * 删除订单
 * @returns {*}
 */
export function delOrder(uni) {
  return request.post("/order/del", { uni });
}

/**
 * 订单查询物流信息
 * @returns {*}
 */
export function express(uni) {
  return request.get("/order/express/" + uni);
}

/**
 * 订单查询物流信息
 * @returns {*}
 */
export function payOrder(uni, paytype, from) {
  return request.post("/order/pay", { uni, paytype, from });
}
/**
 * 订单核销
 * @returns {*}
 */
export function orderVerific(verify_code, is_confirm) {
  return request.post("/order/order_verific", { verify_code, is_confirm });
}
/**
 * 再次下单
 * @param string uni
 *
 */
export function orderAgain(uni) {
  return request.post("/order/again", { uni: uni });
}
